// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_znb","credits":"e_Anb","badgeContainer":"e_Bnb","badge":"e_Cnb"};